import { render } from "./CoffeeIcon.vue?vue&type=template&id=19b4578a"
import script from "./CoffeeIcon.vue?vue&type=script&lang=js"
export * from "./CoffeeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__